
import { defineComponent, SetupContext, computed, ref } from "vue";
import NativeClient from "@/client/native-client";
import { FOLDER_ID_ALL } from "@/types/recipes";

export default defineComponent({
  name: "MyListFolderListItem",
  props: {
    /**
     * フォルダ画像
     */
    imageUrl: {
      type: String
    },
    /**
     * フォルダ名
     */
    name: {
      type: String,
      required: true
    },
    /**
     * フォルダ内メニュー件数
     */
    numberOfItems: {
      type: Number,
      required: true,
      default: 0
    },
    /**
     * フォルダID
     */
    folderId: {
      type: Number,
      required: true
    },
    /**
     * すべて
     */
    isAll: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const getNumber = () => {
      return String(props.numberOfItems) + "メニュー";
    };
    const isCheck = ref(false);
    const checkedImage = computed(() => {
      if (props.isAll) {
        return require("@/assets/images/icn-check-on-disable.png");
      } else if (isCheck.value) {
        return require("@/assets/images/icn-check-on.png");
      }
      return require("@/assets/images/icn-check-off.png");
    });
    /**
     * チェック
     */
    const checkAction = () => {
      NativeClient.sendDebugLog("MyListFolderListItem check");
      if (props.isAll) {
        return;
      }
      isCheck.value = !isCheck.value;
      context.emit('select-check', props.folderId, isCheck.value);
    };

    return {
      getNumber,
      checkedImage,
      checkAction
    };
  }
});
